import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DISABLED_NOTIFY_MESSAGE } from "@core/constants";
import { environment } from "@env";
import { PeriodEnum } from "@shared/enums/period.enum";
import { GetCarWorkshopAgendaFilters } from "@shared/models/get-car-workshop-agenda-filters";
import { UnavailableSlotDTO } from "@shared/models/unavailable-slot-dto";

@Injectable({
  providedIn: "root"
})
export class CarWorkshopAgendaService {
  private headers = new HttpHeaders({
    [DISABLED_NOTIFY_MESSAGE]: "true"
  });
  private carWorkshopsUrl = "car-workshops/";

  constructor(private http: HttpClient) {}

  /**
   * @param carWorkshopId The id of the car workshop
   * @param filters
   * @returns The unavailable slots of the given car workshop
   */
  getAgenda(carWorkshopId: number, filters: GetCarWorkshopAgendaFilters) {
    const url = `${environment.apiUrl}${this.carWorkshopsUrl}agenda/unavailable-slots/${carWorkshopId}`;
    const paramsString = new URLSearchParams();

    for (const [k, v] of Object.entries(filters))
      paramsString.append(k, v.toString());

    return this.http.get<UnavailableSlotDTO[]>(`${url}?${paramsString}`, {
      headers: this.headers
    });
  }

  /**
   * @param carWorkshopId The id of the car workshop
   * @returns The configured settings of the carworkshop's agenda
   */
  getSettings(carWorkshopId: number) {
    return this.http.get<number>(
      `${environment.apiUrl}${this.carWorkshopsUrl}agenda/settings/${carWorkshopId}`,
      {
        headers: this.headers
      }
    );
  }

  /**
   *
   * @param carWorkshopId The id of the car workshop
   * @param filters
   * @returns The configured settings of the carworkshop's agenda
   */
  updateSettings(
    carWorkshopId: number,
    filters: {
      slots?: number;
    }
  ) {
    const url = `${environment.apiUrl}${this.carWorkshopsUrl}agenda/settings/${carWorkshopId}`;
    const paramsString = new URLSearchParams();

    for (const [k, v] of Object.entries(filters))
      paramsString.append(k, v.toString());

    return this.http.put<number>(
      `${url}?${paramsString}`,
      {},
      {
        headers: this.headers
      }
    );
  }

  /**
   * Sets or removes locks
   * @param carWorkshopId The carworkshop id
   * @param blocks The list of slots to be released or blocked
   */
  block(
    carWorkshopId: number,
    blocks: { blockList: BlockDataDTO[]; unblockList: BlockDataDTO[] }
  ) {
    const url = `${environment.apiUrl}${this.carWorkshopsUrl}agenda/block/${carWorkshopId}`;
    return this.http.put<any>(url, blocks, { responseType: "text" as "json" });
  }
}

interface BlockDataDTO {
  date: string;
  period: PeriodEnum;
}
